import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface HeaderApp {
  id: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-header-toolbar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <nav class="app-nav">
      <button
        *ngFor="let app of apps"
        class="app-nav__tab"
        [class.app-nav__tab--active]="app.id === activeApp"
        (click)="onAppClick(app.id)"
        type="button"
      >
        <i [class]="app.icon"></i>
        <span>{{ app.label }}</span>
      </button>
    </nav>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .app-nav {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 0 24px;
        height: 44px;
        background: #ffffff;
        border-bottom: 1px solid #e5e7eb;
      }

      .app-nav__tab {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 16px;
        border: none;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 500;
        color: #6b7280;
        background: transparent;
        cursor: pointer;
        font-family: inherit;
        transition:
          background 0.15s,
          color 0.15s;
      }

      .app-nav__tab:hover {
        background: #f3f4f6;
        color: #374151;
      }

      .app-nav__tab--active {
        background: #eff6ff;
        color: #2474bb;
      }
    `,
  ],
})
export class HeaderToolbarComponent {
  @Input() apps: HeaderApp[] = [];
  @Input() activeApp = '';

  @Output() appChange = new EventEmitter<string>();

  onAppClick(id: string) {
    this.activeApp = id;
    this.appChange.emit(id);
  }
}
